<div class="login_page itc-kds" [class.light]="theme == 'light'" [class.kvs]="isKVSPortal" [class.customBranded]="customBranding">

  @if (!loading && (!siteParams || !siteParams.BannerUrl)) {
    <a class="kaseya_logo ir" href="https://www.kaseya.com/">Kaseya</a>
  }
  @if (siteParams && siteParams.BannerUrl) {
    <div class="left-top-logo"><img [src]="siteParams.BannerUrl" /></div>
  }

  <div class="login_outer_container">
    <div class="login_container">

      <div class="logoContainer">
        <h1 class="title-logo">Employee Portal</h1>

      </div>

      @if (siteParams) {
        @if (siteParams.MicrosoftAuthEnabled) {
          <button class="ui  fluid button primary large" (click)="loginWithMS()">Login With Office 365</button>
        }
        @if (siteParams.GoogleAuthEnabled) {
          <iframe  #giframe style="height:50px;border: none;overflow: hidden;" scrolling="no" [src]="googleIframeUrl"></iframe>
        }
      }
      @if (!loading && (!siteParams || (!siteParams.MicrosoftAuthEnabled && !siteParams.GoogleAuthEnabled))) {
        <div class="ui  fluid"><b>Logins currently disabled</b></div>
      }
    </div>
  </div>
  <p class='login_copyright'>
    <a href="https://support.rapidfiretools.com/hc/en-us" target="_blank">Help &amp; Support</a> |
    &copy; Kaseya {{ currentYear }}
  </p>

  <div class='login_footer_copy' style="position: fixed; right: 15px; bottom: 0;">
    <p class='footer_version' style="margin-left: 20px;" >v.{{ version }}</p>
  </div>
</div>


